import script from "./SalaireView.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaireView.vue?vue&type=script&setup=true&lang=js"

import "./SalaireView.vue?vue&type=style&index=0&id=78f5b15a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78f5b15a"]])

export default __exports__